import { CbhFeatureFlag, useCbhFlag } from "../FeatureFlags";
import { PlacementAccessControlStatus } from "../FeatureFlags/CbhFeatureFlags";

/**
 * Browse Talent Pool can be enabled independently of the rest of the permanent
 * hiring features via the `browse-only` status, which surfaces only the talent
 * pool while leaving interview schedule, applications, and jobs hidden.
 */
export function getCanBrowseTalentPool(accessLevel: PlacementAccessControlStatus): boolean {
  return (
    accessLevel === PlacementAccessControlStatus.VIEW ||
    accessLevel === PlacementAccessControlStatus.EDIT_PAID ||
    accessLevel === PlacementAccessControlStatus.BROWSE_ONLY
  );
}

export function useGetPlacementsAccessLevel() {
  const flagValue = useCbhFlag(CbhFeatureFlag.PLACEMENTS_ACCESS_CONTROL_ROLLOUT, {
    defaultValue: PlacementAccessControlStatus.OFF,
  });
  return {
    isEnabled:
      flagValue === PlacementAccessControlStatus.EDIT_PAID ||
      flagValue === PlacementAccessControlStatus.EDIT_FREE ||
      flagValue === PlacementAccessControlStatus.VIEW,
    canBrowseTalentPool: getCanBrowseTalentPool(flagValue),
    accessLevel: flagValue,
  };
}

interface CanCreateOrEditPlacementsParams {
  accessLevel: PlacementAccessControlStatus;
  admin: boolean;
  isManagedByParentWorkplace: boolean;
}

export function getCanCreateOrEditPlacements(params: CanCreateOrEditPlacementsParams) {
  const { accessLevel, admin, isManagedByParentWorkplace } = params;

  return (
    (!isManagedByParentWorkplace &&
      (accessLevel === PlacementAccessControlStatus.EDIT_PAID ||
        accessLevel === PlacementAccessControlStatus.EDIT_FREE)) ||
    admin
  );
}

export function shouldShowAdminPlacementsViewOnlyNotice(params: {
  accessLevel: PlacementAccessControlStatus;
  admin: boolean;
}) {
  return params.accessLevel === PlacementAccessControlStatus.VIEW && params.admin;
}
